import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CommonListQuery, } from '../../../../redux/api/apiTypes';
import { ReportParams, FieldReprtResponse, FieldItem } from './apiTypes';
import moment from 'moment';
import { format } from 'date-fns';

export const fieldReportApi = createApi({
    reducerPath: 'fieldReportApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + "/api/v1/reports",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getFieldReport: builder.query<FieldItem[], { searchParam?: ReportParams } & Partial<CommonListQuery>>({
            query: (body) => ({
                url: `/init/search?page_number=${body.page || 0}&page_size=${body.size || 10}`,
                method: 'POST',
                body: {
                    accounts: body?.searchParam?.accounts,
                    field: body?.searchParam?.field,
                    types: body?.searchParam?.typeId,
                    from_date: body?.searchParam?.dates && body.searchParam.dates[0] ? moment(body.searchParam.dates[0]).format("YYYY-MM-DD") : undefined,
                    to_date: body?.searchParam?.dates && body.searchParam.dates[1] ? moment(body.searchParam.dates[1]).format("YYYY-MM-DD") : undefined
                }
            }),
            transformResponse: (response: { data: FieldItem[] }, meta, arg) => {
                return response.data;
            },
        }),
        getFieldReportTotal: builder.query<number, { searchParam?: ReportParams } & Partial<CommonListQuery>>({
            query: (body) => ({
                url: `/init/records/amount`,
                method: 'POST',
                body: body
            }),
            transformResponse: (response: { data: number }, meta, arg) => {
                return response.data;
            },
        }),
        exportData: builder.mutation<any, { searchParam?: ReportParams } & Partial<CommonListQuery>>({
            query: (body) => ({
                url: `/init/export`,
                method: 'POST',
                params: {
                    sort_type: 0
                },
                body: {
                    accounts: body?.searchParam?.accounts,
                    field: body?.searchParam?.field,
                    types: body?.searchParam?.typeId,
                    from_date: body?.searchParam?.dates && body.searchParam.dates[0] ? moment(body.searchParam.dates[0]).format("YYYY-MM-DD") : undefined,
                    to_date: body?.searchParam?.dates && body.searchParam.dates[1] ? moment(body.searchParam.dates[1]).format("YYYY-MM-DD") : undefined
                },
                responseHandler: async (response) => {
                    let filename = `${format(new Date(), "dd-MM-yyyy")}_Báo cáo theo trường dữ liệu.xlsx`;
                    let blob = await response.blob();
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename);
                    link.click();
                },
                cache: "no-cache",
            }),
        }),
    })
})

export const {
    useLazyGetFieldReportQuery,
    useLazyGetFieldReportTotalQuery,
    useExportDataMutation,
} = fieldReportApi;

export default fieldReportApi;